import { LANGUAGE_KEY } from "gatsby-plugin-react-i18next/dist/types"
import {
  DEFAULT_LANGUAGE,
  WatchProjectLanguages,
} from "../../../plugins/watchproject-localized-urls/const"
import {
  generateNewTranslatedUrl,
  getUrlMappingEntryByRouteKey,
} from "../i18n/route-translations"

const getRouteTranslation = (routeKey: string) => {
  let language = "es" as WatchProjectLanguages
  if (typeof localStorage !== "undefined") {
    // default to spanish if we are in the server
    language =
      (localStorage.getItem(LANGUAGE_KEY) as WatchProjectLanguages) || "es"
  }

  const pathMappingObject = getUrlMappingEntryByRouteKey(routeKey)

  if (!pathMappingObject) {
    console.error(`Path '${routeKey}' not found`)
    return routeKey
  }

  const { url } = generateNewTranslatedUrl(
    pathMappingObject.translations[language],
    language,
    language
  )

  if (language !== DEFAULT_LANGUAGE) {
    return url
  }

  return url
}

/**
 * All of the following keys match with the route keys in the url-mappings.json file
 */

export const SELLING_FORM_SUCCESS_ROUTE = getRouteTranslation("sell-form")

export const ABOUT_US_ROUTE = getRouteTranslation("about-us")

export const CONTACT_ROUTE = getRouteTranslation("contact")

export const SELLING_INDEX_ROUTE = getRouteTranslation("sell")

export const SELLING_SEARCH_ROUTE = getRouteTranslation("sell-search")

export const SELLING_PRODUCT_FORM_ROUTE = (slug: string) =>
  getRouteTranslation("sell-product-form")
    .replace("{*}", slug)
    .replace("//", "/")

export const SELLING_PRODUCT_VALORACION_ROUTE = (slug: string) =>
  getRouteTranslation("sell-product-valoracion")
    .replace("{*}", slug)
    .replace("//", "/")

export const BUYING_PRODUCTS_ROUTE = (slug: string) =>
  getRouteTranslation("buy-products").replace("{*}", slug).replace("//", "/")

export const BUYING_INDEX_ROUTE = getRouteTranslation("buy")

export const BUYING_CATALOG_ROUTE = (slug: string = "") =>
  getRouteTranslation("catalog").replace("{*}", slug).replace("//", "/")
